<template>
  <div class="col-12 page_content_area page_article_area">
    <div class="container page_article_block px-4">
      <div class="row">
        <slot name="meta" />
      </div>
      <div class="row pt-2 pb-4">
        <div class="col">
          <h2>{{ pageTitle }}</h2>
        </div>
      </div>
      <div class="row">
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="col-12"
          v-html="pageContentHtml"
        />
        <slot />
      </div>
      <div class="row">
        <div class="col-12 article_footer">
            <div class="file_area">
                <div
                    v-show="attachments.length > 0"
                    class="file_title"
                >
                    <font-awesome-icon icon="paperclip" />附件
                </div>
                <div
                    v-show="attachments.length > 0"
                    class=""
                >
                    <div class="file_list">
                        <div
                            v-for="attachment in attachments"
                            :key="attachment.attachment_id"
                            class="file_item"
                        >
                            <font-awesome-icon
                                :icon="attachment.attachment_icon"
                            />
                            <a
                                :href="`${attachment.attachment_url}`"
                                target="_blank"
                            >
                                <template v-if="attachment.attachment_file_name.length > 10">
                                    {{ attachment.attachment_file_name.slice(0, 10) }}....{{ attachment.attachment_file_extension }}
                                </template>
                                <template v-else>
                                    {{ attachment.attachment_file_name }}
                                </template>

                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="print_area"
                :class="{
                'offset-10': attachments.length < 1
                }"
            >
                <circle-icon-button
                    title="友善列印"
                    @click="openPrintPreview"
                >
                    <img src="/images/icon_print.svg">
                </circle-icon-button>
            </div>
        </div>
    </div>
</div>
</div>
</template>
<script>
import CircleIconButton from '~components/common/buttons/CircleIcon'
export default {
  name: 'PageArticle',
  components: {
    CircleIconButton
  },
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    pageContentHtml: {
      type: String,
      default: ''
    },
    attachments: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    openPrintPreview () {
      window.print()
    }
  }
}
</script>
